<div style="padding: 15px 0px;">
    <div data-test-id="skipLogicQuestion">
        {{question.content.text | replacePatientTerm : question.content.patientTerms : patientTerm}}
    </div>
    <label id="radio-group-label">
        <mat-radio-group data-test-id="skipLogicRadioButtonAnswers" aria-labelledby="radio-group-label" class="radio-group">
            <mat-radio-button class="radio-button" *ngFor="let answer of answersRadio" [value]="answer"  [checked]="answer.selected" (change)="saveSelectionRadio(answer)">
            {{answer.content.text | replacePatientTerm : answer.content.patientTerms : patientTerm!}}                      
            </mat-radio-button> 
        </mat-radio-group>
    </label>
    <div data-test-id="skipLogicCheckboxButtonAnswers" *ngFor="let answer of answersCheckbox">
        <mat-checkbox class="checkbox-button" [ngModel]="answer.selected" (ngModelChange)="onChangeCheckbox(answer, $event)" [disabled]="isCheckboxesDisabled" >
            <span [innerHTML]="answer.content.text | replacePatientTerm : answer.content.patientTerms : patientTerm!"></span>
        </mat-checkbox>
        <input 
            matInput 
            *ngIf="answer.scaleValue === '996'" 
            type="text"
            class="input-textbox" aria-labelledby="radio-check- label" 
            [ngClass]="{'input-textbox-error': !isOtherTextboxInCheckboxValid}"
            [ngModel]="question.responseText"
            (ngModelChange)="updateOtherTextBoxValidity($event)"
            (focusout)="saveOtherTextBoxAnswer(answer)"
            #myTextArea 
            [disabled]="isOtherTextBoxInCheckboxDisabled" 
            maxlength="{{this.maxOtherAnswerCount}}" 
            placeholder="{{this.otherAnswerPlaceholder}}"
        >  
    </div>
    <mat-divider></mat-divider>
</div>